import { render, staticRenderFns } from "./_message.vue?vue&type=template&id=364989a2&scoped=true"
import script from "./_message.vue?vue&type=script&lang=js"
export * from "./_message.vue?vue&type=script&lang=js"
import style0 from "./_message.vue?vue&type=style&index=0&id=364989a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364989a2",
  null
  
)

export default component.exports